import { createContext } from 'react';

import type { PointsDisplay } from '../../core/components/canvas/types/canvas-shape.js';

export const TimeseriesPointsDisplayContext =
  createContext<PointsDisplay>('auto');

TimeseriesPointsDisplayContext['displayName'] =
  'TimeseriesPointsDisplayContext';
